// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file giftcards_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { Giftcard } from "./giftcard_pb";
import { file_giftcard } from "./giftcard_pb";
import type { GiftcardProduct } from "./giftcard_product_pb";
import { file_giftcard_product } from "./giftcard_product_pb";
import type { GiftcardTransaction } from "./giftcard_transaction_pb";
import { file_giftcard_transaction } from "./giftcard_transaction_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file giftcards_service.proto.
 */
export const file_giftcards_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_empty, file_giftcard, file_giftcard_product, file_giftcard_transaction]);

/**
 * @generated from message grpc.api.v1.GiftcardsProductRequets
 */
export type GiftcardsProductRequets = Message<"grpc.api.v1.GiftcardsProductRequets"> & {
  /**
   * @generated from field: grpc.api.v1.GiftcardProduct product = 1;
   */
  product?: GiftcardProduct | undefined;
};

/**
 * Describes the message grpc.api.v1.GiftcardsProductRequets.
 * Use `create(GiftcardsProductRequetsSchema)` to create a new message.
 */
export const GiftcardsProductRequetsSchema: GenMessage<GiftcardsProductRequets> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 0);

/**
 * @generated from message grpc.api.v1.GiftcardsProductResponse
 */
export type GiftcardsProductResponse = Message<"grpc.api.v1.GiftcardsProductResponse"> & {
  /**
   * @generated from field: grpc.api.v1.GiftcardProduct product = 1;
   */
  product?: GiftcardProduct | undefined;
};

/**
 * Describes the message grpc.api.v1.GiftcardsProductResponse.
 * Use `create(GiftcardsProductResponseSchema)` to create a new message.
 */
export const GiftcardsProductResponseSchema: GenMessage<GiftcardsProductResponse> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 1);

/**
 * @generated from message grpc.api.v1.GiftcardsListTransactionsParams
 */
export type GiftcardsListTransactionsParams = Message<"grpc.api.v1.GiftcardsListTransactionsParams"> & {
  /**
   * @generated from field: int32 begin_date = 1;
   */
  beginDate: number;

  /**
   * @generated from field: int32 end_date = 2;
   */
  endDate: number;

  /**
   * @generated from field: repeated string types = 3;
   */
  types: string[];

  /**
   * @generated from field: repeated string giftcard_codes = 4;
   */
  giftcardCodes: string[];

  /**
   * @generated from field: string giftcard_code = 5;
   */
  giftcardCode: string;
};

/**
 * Describes the message grpc.api.v1.GiftcardsListTransactionsParams.
 * Use `create(GiftcardsListTransactionsParamsSchema)` to create a new message.
 */
export const GiftcardsListTransactionsParamsSchema: GenMessage<GiftcardsListTransactionsParams> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 2);

/**
 * @generated from message grpc.api.v1.GiftcardsListTransactionsRequest
 */
export type GiftcardsListTransactionsRequest = Message<"grpc.api.v1.GiftcardsListTransactionsRequest"> & {
  /**
   * @generated from field: grpc.api.v1.GiftcardsListTransactionsParams params = 1;
   */
  params?: GiftcardsListTransactionsParams | undefined;
};

/**
 * Describes the message grpc.api.v1.GiftcardsListTransactionsRequest.
 * Use `create(GiftcardsListTransactionsRequestSchema)` to create a new message.
 */
export const GiftcardsListTransactionsRequestSchema: GenMessage<GiftcardsListTransactionsRequest> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 3);

/**
 * @generated from message grpc.api.v1.GiftcardsListTransactionsResponse
 */
export type GiftcardsListTransactionsResponse = Message<"grpc.api.v1.GiftcardsListTransactionsResponse"> & {
  /**
   * @generated from field: grpc.api.v1.GiftcardsListTransactionsParams params = 1;
   */
  params?: GiftcardsListTransactionsParams | undefined;

  /**
   * @generated from field: grpc.api.v1.GiftcardTransaction transaction = 2;
   */
  transaction?: GiftcardTransaction | undefined;
};

/**
 * Describes the message grpc.api.v1.GiftcardsListTransactionsResponse.
 * Use `create(GiftcardsListTransactionsResponseSchema)` to create a new message.
 */
export const GiftcardsListTransactionsResponseSchema: GenMessage<GiftcardsListTransactionsResponse> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 4);

/**
 * @generated from message grpc.api.v1.GiftcardsListGiftcardsRequest
 */
export type GiftcardsListGiftcardsRequest = Message<"grpc.api.v1.GiftcardsListGiftcardsRequest"> & {
  /**
   * @generated from field: repeated string statuses = 1;
   */
  statuses: string[];
};

/**
 * Describes the message grpc.api.v1.GiftcardsListGiftcardsRequest.
 * Use `create(GiftcardsListGiftcardsRequestSchema)` to create a new message.
 */
export const GiftcardsListGiftcardsRequestSchema: GenMessage<GiftcardsListGiftcardsRequest> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 5);

/**
 * @generated from message grpc.api.v1.GiftcardsListGiftcardsResponse
 */
export type GiftcardsListGiftcardsResponse = Message<"grpc.api.v1.GiftcardsListGiftcardsResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Giftcard giftcard = 1;
   */
  giftcard?: Giftcard | undefined;
};

/**
 * Describes the message grpc.api.v1.GiftcardsListGiftcardsResponse.
 * Use `create(GiftcardsListGiftcardsResponseSchema)` to create a new message.
 */
export const GiftcardsListGiftcardsResponseSchema: GenMessage<GiftcardsListGiftcardsResponse> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 6);

/**
 * @generated from message grpc.api.v1.GiftcardsRedeemGiftcardRequest
 */
export type GiftcardsRedeemGiftcardRequest = Message<"grpc.api.v1.GiftcardsRedeemGiftcardRequest"> & {
  /**
   * @generated from field: int64 giftcard_id = 1;
   */
  giftcardId: bigint;

  /**
   * @generated from field: string giftcard_code = 2;
   */
  giftcardCode: string;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * @generated from field: int64 balance = 4;
   */
  balance: bigint;

  /**
   * @generated from field: string idempotency_key = 5;
   */
  idempotencyKey: string;
};

/**
 * Describes the message grpc.api.v1.GiftcardsRedeemGiftcardRequest.
 * Use `create(GiftcardsRedeemGiftcardRequestSchema)` to create a new message.
 */
export const GiftcardsRedeemGiftcardRequestSchema: GenMessage<GiftcardsRedeemGiftcardRequest> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 7);

/**
 * @generated from message grpc.api.v1.GiftcardsGetGiftcardRequest
 */
export type GiftcardsGetGiftcardRequest = Message<"grpc.api.v1.GiftcardsGetGiftcardRequest"> & {
  /**
   * @generated from field: int64 giftcard_id = 1;
   */
  giftcardId: bigint;

  /**
   * @generated from field: string giftcard_code = 2;
   */
  giftcardCode: string;
};

/**
 * Describes the message grpc.api.v1.GiftcardsGetGiftcardRequest.
 * Use `create(GiftcardsGetGiftcardRequestSchema)` to create a new message.
 */
export const GiftcardsGetGiftcardRequestSchema: GenMessage<GiftcardsGetGiftcardRequest> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 8);

/**
 * @generated from message grpc.api.v1.GiftcardsGiftcardResponse
 */
export type GiftcardsGiftcardResponse = Message<"grpc.api.v1.GiftcardsGiftcardResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Giftcard giftcard = 1;
   */
  giftcard?: Giftcard | undefined;
};

/**
 * Describes the message grpc.api.v1.GiftcardsGiftcardResponse.
 * Use `create(GiftcardsGiftcardResponseSchema)` to create a new message.
 */
export const GiftcardsGiftcardResponseSchema: GenMessage<GiftcardsGiftcardResponse> = /*@__PURE__*/
  messageDesc(file_giftcards_service, 9);

/**
 * @generated from service grpc.api.v1.GiftcardsService
 */
export const GiftcardsService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.GiftcardsService.getProduct
   */
  getProduct: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof GiftcardsProductResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.GiftcardsService.updateProduct
   */
  updateProduct: {
    methodKind: "unary";
    input: typeof GiftcardsProductRequetsSchema;
    output: typeof GiftcardsProductResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.GiftcardsService.listTransactions
   */
  listTransactions: {
    methodKind: "server_streaming";
    input: typeof GiftcardsListTransactionsRequestSchema;
    output: typeof GiftcardsListTransactionsResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.GiftcardsService.listGiftcards
   */
  listGiftcards: {
    methodKind: "server_streaming";
    input: typeof GiftcardsListGiftcardsRequestSchema;
    output: typeof GiftcardsListGiftcardsResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.GiftcardsService.getGiftcard
   */
  getGiftcard: {
    methodKind: "unary";
    input: typeof GiftcardsGetGiftcardRequestSchema;
    output: typeof GiftcardsGiftcardResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.GiftcardsService.redeemGiftcard
   */
  redeemGiftcard: {
    methodKind: "unary";
    input: typeof GiftcardsRedeemGiftcardRequestSchema;
    output: typeof GiftcardsGiftcardResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_giftcards_service, 0);

